<ion-toggle
  (ionChange)="checkedChange($event)"
  [checked]="value()"
  class="{{ styleClass() }}"
  >{{ label() }}</ion-toggle
>
